<template>
    <div class="fl-visitor-check">
        <div class="container">
            <div>
                <h2>Онлайн-проверка ФЛ</h2>
            </div>
            <div class="fl-visitor-check__tabs">
                <div :class="{ 'fl-visitor-check__tabs__tab': true, 'fl-visitor-check__tabs__tab_active': switcher.flCheckExpress }" @click="setFlCheckTab('flCheckExpress')">Экспресс</div>
                <span style="display: inline-block; margin: 0 5px 0 -5px; font-size: 24px; font-weight: 400;">|</span>
                <div :class="{ 'fl-visitor-check__tabs__tab': true, 'fl-visitor-check__tabs__tab_active': switcher.flCheckStandart }" @click="setFlCheckTab('flCheckStandart')">Стандарт</div>
                <span style="display: inline-block; margin: 0 5px 0 -5px; font-size: 24px; font-weight: 400;">|</span>
                <div :class="{ 'fl-visitor-check__tabs__tab': true, 'fl-visitor-check__tabs__tab_active': switcher.flCheckOptimum }" @click="setFlCheckTab('flCheckOptimum')">Оптимум</div>
                <span style="display: inline-block; margin: 0 5px 0 -5px; font-size: 24px; font-weight: 400;">|</span>
                <div :class="{ 'fl-visitor-check__tabs__tab': true, 'fl-visitor-check__tabs__tab_active': switcher.flCheckMaximum }" @click="setFlCheckTab('flCheckMaximum')">Максимум</div>
                <span style="display: inline-block; margin: 0 5px 0 -5px; font-size: 24px; font-weight: 400;">|</span>
                <div :class="{ 'fl-visitor-check__tabs__tab': true, 'fl-visitor-check__tabs__tab_active': switcher.addressCheck }" @click="setFlCheckTab('addressCheck')">Адрес</div>
            </div>
            <div class="container">
                <flCheckExpress v-if="switcher.flCheckExpress" />
                <flCheckStandart v-if="switcher.flCheckStandart" />
                <flCheckOptimum v-if="switcher.flCheckOptimum" />
                <flCheckMaximum v-if="switcher.flCheckMaximum" />
                <addressCheck v-if="switcher.addressCheck" />
            </div>
        </div>
    </div>
</template>

<script>
import flCheckExpress from './_flCheckExpress.vue'
import flCheckStandart from './flCheck/flCheckStandart.vue'
import flCheckOptimum from './flCheckOptimum/flCheckOptimum.vue'
import flCheckMaximum from './_flCheckMaximum.vue'
import addressCheck from './addressCheck/addressCheck.vue'

/* NOTE какие ФЛ проверки какие
    Экспресс (- стандартная в корп системе)
    Стандарт (- расширенная проверка в корп системе)
    Оптимум (- Расширенный поиск и проверка в ЛЭ)
    Максимум (это текущая Проверка ФЛ в корп-системах, слева которая на главном экране)
*/

export default {
    components: {
        flCheckExpress,
        flCheckStandart,
        flCheckOptimum,
        flCheckMaximum,
        addressCheck
    },
    data() {
        return {
            extended: false,
            switcher: {
                flCheckExpress: true,
                flCheckStandart: false,
                flCheckOptimum: false,
                flCheckMaximum: false,
                addressCheck: false
            }
        }
    },
    methods: {
        setFlCheckTab(tabName) {
            Object.keys(this.switcher).forEach(e => {
                this.switcher[e] = false
            })

            this.switcher[tabName] = true
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables.sass'

.fl-visitor-check
    @include page
    h2
        @include page-heading
    // .container
    //     width: 1280px
    //     margin: 0 auto
    &__tabs
        margin-top: 20px
        &__tab
            font-weight: 400
            cursor: pointer
            margin-right: 15px
            display: inline-block
            font-size: 24px
            font-family: Gotham Pro, Courier New, Courier, monospace
            color: #333
            pdding-bottom: 5px
            &:not(&_active):hover
                color: #005B9B
            &_active
                cursor: default
                color: #D24135
                border-bottom: 2px solid #005B9B
</style>